import React from "react";
import { Grid, TextField, Box, Divider } from "@mui/material";
import Chip from "@mui/material/Chip";
import Fab from "@mui/material/Fab";
import AddIcon from "@mui/icons-material/Add";
import FormHelperText from "@mui/material/FormHelperText";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Typography from "@mui/material/Typography";
import { Alert, AlertTitle } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import SearchField from "react-search-field";

export default function Applications(props) {
  let { OSTYPE, appsetFormFields, appfieldIndex, setDevopsport } = props;
  const [customtools, setCustomTools] = React.useState([[]]);
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = (e) => {
    setOpen(true);
    fetch(`${process.env.REACT_APP_API_URL}/api/svmtools/${OSTYPE}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((resp) => {
        setCustomTools(resp)
      })
      // .then((resp) => setCustomTools(resp))
      .catch((error) => {
        console.error(error);
      });
  };
  const handleClose = () => {
    setOpen(false);
  };

  const [selectedValue, setSelectedValue] = React.useState([]);
  const [selectedPorts, setSelectedPorts] = React.useState([]);
  const [selectedApps, setSelectedApps] = React.useState([]);
  const [forversion, setForversion] = React.useState([]);
  const [selectedVersions, setSelectedVersions] = React.useState([]);


  const handleCancel = () => {
    setOpen(false);
    setSelectedValue([]);
    setForversion([]);
    setSelectedVersions([]);
    setSelectedApps([]);
    setSelectedPorts([]);
  };

  const handleChange = (e, index, ports) => {
    const { id, value } = e.target;
    if (selectedValue[value]) {
      setSelectedValue((prevState) => ({
        ...prevState,
        [value]: false,
      }));
      if (ports !== null) {
        setSelectedPorts((prevState) => ({
          ...prevState,
          [ports]: false,
        }));
        setSelectedApps((prevState) => ({
          ...prevState,
          [ports]: "",
        }));
      }
      setForversion((prevState) => ({
        ...prevState,
        [index]: "",
      }));
      setSelectedVersions((prevState) => ({
        ...prevState,
        [value]: "",
      }));
    } else {
      setSelectedValue((prevState) => ({
        ...prevState,
        [value]: e.target.checked,
      }));
      if (ports !== null) {
        setSelectedPorts((prevState) => ({
          ...prevState,
          [ports]: true,
        }));
        setSelectedApps((prevState) => ({
          ...prevState,
          [ports]: value,
        }));
      }
      if (value) {
        const apipostval = value + "-" + OSTYPE; //OSTYPE
        fetch(
          `${process.env.REACT_APP_API_URL}/api/svmversionlist/${apipostval}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        )
          .then((resp) => resp.json())
          .then((resp) =>
            setForversion((prevState) => ({
              ...prevState,
              [index]: resp,
            }))
          )
          .catch((error) => {
            console.error(error);
          });
      }
    }
  };

  const [blockapps, setBlockapps] = React.useState(false);
  const [apperror, setApperror] = React.useState(false);

  const [formFields, setFormFields] = React.useState([]);

  const handleChangeInput = (e, index, appname) => {
    const { id, value } = e.target;
    setSelectedVersions((prevState) => ({
      ...prevState,
      [appname]: value,
    }));
  };

  const handleSumbitClick = (e) => {
    let assignAppValue = [];
    let assignAppports = [];
    let count = 0;
    let version;
    customtools.map((appdata) => {
      if (selectedValue[appdata.Name]) {
        if (selectedVersions[appdata.Name]) {
          version = selectedVersions[appdata.Name];
          const appval = `${appdata.Name.trim()}-${version.trim()}`;
          assignAppValue.push(appval);
          assignAppports.push(appdata.Ports);
        } else {
          count = count + 1;
        }
      }
    });
    if (count > 0) {
      setApperror(true);
    } else {
      setApperror(false);
      appsetFormFields((prevState) => ({
        ...prevState,
        [appfieldIndex]: assignAppValue,
      }));
      setDevopsport((prevState) => ({
        ...prevState,
        [appfieldIndex]: assignAppports,
      }));
      setOpen(false);
    }
  };

  const [searchitems, setSearchItems] = React.useState(0);

  return (
    <>
      <div>
        <Fab 
          variant="extended" 
          size="small" 
          color="primary" 
          aria-label="add"
          sx={{ borderRadius: '16px' }}
        >
          <Chip
            icon={<AddIcon />}
            label="Tools"
            clickable
            color="primary"
            onClick={handleClickOpen}
          />
        </Fab>
      </div>
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        maxWidth="md"
        scroll="paper"
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
      >
        <DialogTitle id="scroll-dialog-title">SVM---Tools </DialogTitle>
        {blockapps ? (
          <Alert severity="warning">
            <AlertTitle>Warning</AlertTitle>
            Don't choose multiple applications with same port!
          </Alert>
        ) : (
          ""
        )}
        {apperror ? (
          <Alert severity="warning">
            <AlertTitle>Warning</AlertTitle>
            Please make sure all the fields are selected.
          </Alert>
        ) : (
          ""
        )}
        <DialogContent dividers>
          <SearchField
            value={searchitems}
            placeholder="Search..."
            onChange={(event) => {
              setSearchItems(event);
            }}
            classNames="test-class"
          />
          <DialogContentText id="scroll-dialog-description" tabIndex={-1}>
            <Box>
              {customtools ? (
                <React.Fragment>
                  <Grid container spacing={1}>
                    <Grid item xs={8}>
                      <Grid container spacing={0} sx={{ mt: 3 }}>
                        <Grid item xs={8}>
                          <Typography variant="h8" gutterBottom>
                            Tools
                          </Typography>
                        </Grid>
                        <Grid item xs={2}>
                          <Typography variant="h8" gutterBottom>
                            Version
                          </Typography>
                        </Grid>
                      </Grid>
                      <Divider />
                      {customtools
                        .filter((val) => {
                          if (searchitems == "") {
                            return val;
                          } else if (
                            val.Title.toLowerCase().includes(
                              searchitems.toLowerCase()
                            )
                          ) {
                            return val;
                          }
                        })
                        .map((e, index) => {
                          let ports = e.Ports;
                          let appname = e.Name;
                          return (
                            <Grid container spacing={0} sx={{ mt: 3 }}>
                              <Grid item xs={8}>
                                <Checkbox
                                  checked={selectedValue[e.Name]}
                                  onChange={(e) =>
                                    handleChange(e, index, ports)
                                  }
                                  disabled={
                                    selectedApps[ports] !== e.Name &&
                                    selectedPorts[ports]
                                  }
                                  value={e.Name}
                                  inputProps={{
                                    "aria-label": "primary checkbox",
                                  }}
                                />                                
                                <Typography variant="h8" gutterBottom>
                                  {`${e.Title}`}
                                </Typography>
                               <FormHelperText sx={{ ml: 5 }}>min req: {e.requirements}</FormHelperText>
                              </Grid>
                              <Grid item xs={2}>
                                <TextField
                                  fullWidth
                                  name={`version`}
                                  id={`version`}
                                  onChange={(e) =>
                                    handleChangeInput(e, index, appname)
                                  }
                                  required
                                  select
                                  SelectProps={{ native: true }}
                                  autoComplete="name"
                                >
                                  <option value="">
                                    --Select the Version--
                                  </option>
                                  {forversion[index] &&
                                    forversion[index]
                                      .split(",")
                                      .map((appdata) => {
                                        return (
                                          <React.Fragment>
                                            <option value={appdata}>
                                              {appdata}
                                            </option>
                                          </React.Fragment>
                                        );
                                      })}
                                </TextField>
                              </Grid>
                            </Grid>
                          );
                        })}
                    </Grid>
                    <Grid item xs={4}>
                      <Box
                        sx={{
                          fontStyle: "italic",
                          height: "100%",
                          backgroundColor: "whitesmoke",
                        }}
                        borderColor="error.main"
                        border={1}
                      >
                        <strong>Choosen Tools :</strong>
                        {customtools.map((e, index) => {
                          if (
                            selectedValue[e.Name] &&
                            !selectedVersions[e.Name]
                          ) {
                            return (
                              <li style={{ textAlignLast: "center" }}>{`${e.Name}-<Version>`}</li>
                            );
                          } else if (
                            selectedValue[e.Name] &&
                            selectedVersions[e.Name]
                          ) {
                            return (
                              <li style={{ textAlignLast: "center" }}>{`${
                                e.Name
                              }-${selectedVersions[e.Name]}`}</li>
                            );
                          }
                        })}
                      </Box>
                    </Grid>
                  </Grid>
                </React.Fragment>
              ) : (
                ""
              )}
            </Box>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Tooltip title="Close dialog without saving">
            <Button onClick={handleClose} variant="contained" color="primary" sx={{ borderRadius: '50px' }}>
              Close
            </Button>
          </Tooltip>
          <Tooltip title="Cancel and discard changes">
            <Button onClick={handleCancel} variant="contained" color="primary" sx={{ borderRadius: '50px' }}>
              Cancel
            </Button>
          </Tooltip>
          <Tooltip title="Save changes">
            <Button onClick={handleSumbitClick} variant="contained" color="primary" sx={{ borderRadius: '50px' }}>
              Save
            </Button>
          </Tooltip>
        </DialogActions>
      </Dialog>
    </>
  );
}
